export const theme = {
    color: {
        black: "#000",
        silver: "#C0C0C0",
        alto: "#DBDBDB",
        gallery: "#ECECEC",
        white: "#fff",
        teal: "#008080",
        crimson: "#DC143C",
        forestGreen: "#228B22",

    },

    breakpoint: {
        mobileMax: 767,
    },
};